import { render, staticRenderFns } from "./GlossesByReason.vue?vue&type=template&id=5e1b3fc9"
import script from "./GlossesByReason.vue?vue&type=script&lang=js"
export * from "./GlossesByReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports